import * as Sentry from '@sentry/react'
Sentry.init({
  dsn: 'https://bd7ba4706f86f7c6e9a981904d94e8bf@o4508286797283328.ingest.us.sentry.io/4510381422870528',
  environment: import.meta.env.PROD ? 'production' : 'development',
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  tracesSampleRate: 1.0,
  integrations: [Sentry.browserTracingIntegration()],
  _experiments: {
    enableMetrics: true,
  },
  ignoreErrors: [
    // CefSharp bot errors from Microsoft Outlook SafeSearch and similar automated security scanners.
    // These occur when bots scan links in emails for safety. The error originates from CefSharp's
    // JavascriptObjectRepository when it tries to update objects that were garbage collected.
    // Evidence: https://github.com/cefsharp/CefSharp/discussions/3633
    //           https://trackjs.com/javascript-errors/object-not-found-matching-id-methodname-paramcount/
    /Object Not Found Matching Id.*MethodName.*ParamCount/,
  ],
})
